// @flow
import React, { Component } from 'react';
import { SignupsDiv, SignupsBorderAside } from './SignupsStyles';
import SignupStat from './SignupStat';
import { type SignupStats } from '..';
import approvedImage from '../../../../assets/icons/approved-merchants.png';
import pendingImage from '../../../../assets/icons/pending-kyc.png';
import signupsImage from '../../../../assets/icons/new-signups.png';
import partialImage from '../../../../assets/icons/partially-filled.png';
import { MONTH_SIGNUPS } from '../reducer';

type Props = {
  ...$Exact<SignupStats>,
  activeSection: string
};

export default class Signups extends Component<Props> {
  render() {
    return (
      <SignupsDiv>
        <SignupStat
          image={signupsImage}
          label={`New Merchant Signups This ${
            this.props.activeSection === MONTH_SIGNUPS ? 'Month' : 'Year'
          }`}
          value={this.props.signups}
          color="blue"
        />
        <SignupStat
          image={approvedImage}
          label="Merchant Applications Approved"
          value={this.props.approved}
          color="green"
        />
        <SignupsBorderAside />
        <SignupStat
          image={pendingImage}
          label="Merchant Applications Pending KYC Approval"
          value={this.props.pending}
          color="yellow"
        />
        <SignupStat
          image={partialImage}
          label="Merchant Applications Partially Filled Out KYC Approval"
          value={this.props.partial}
          color="orange"
        />
      </SignupsDiv>
    );
  }
}
